import elementBase from "./elementBase.js";

export default class Color extends elementBase {
    objectType = "ColorElement";
    _Color = "";
    RadiusTopLeft = 0.0;
    RadiusTopRight = 0.0;
    RadiusBottomLeft = 0.0;
    RadiusBottomRight = 0.0;
    styleColor = 'rgba(37, 147, 121, 0.49)'; // Gris bleuté
    constructor(args = {}) {
        super(args);
        this.objectToClassValue(args);
    }
    objectToClassValue(args = {}) {
        super.objectToClassValue(args);
        this.Color = args.color ? args.color : "rgba(0, 0, 0, 1)";
        this.RadiusTopLeft = args.radiusTopLeft ? args.radiusTopLeft : 0;
        this.RadiusTopRight = args.radiusTopRight ? args.radiusTopRight : 0;
        this.RadiusBottomLeft = args.radiusBottomLeft ? args.radiusBottomLeft : 0;
        this.RadiusBottomRight = args.radiusBottomRight ? args.radiusBottomRight : 0;
    }
    static variableOfInstance() {
        return [
            ...super.variableOfInstance(),
            { property: "Color", construct: String, jsType: "String" },
            { property: "RadiusTopLeft", construct: Number, jsType: "Number" },
            { property: "RadiusTopRight", construct: Number, jsType: "Number" },
            { property: "RadiusBottomLeft", construct: Number, jsType: "Number" },
            { property: "RadiusBottomRight", construct: Number, jsType: "Number" },
        ];
    }
    static get Name() {
        return "Couleur";
    }
    get Color() {
        return this._Color;
    }
    set Color(value) {
        this._Color = this.harmonizeColorValue(value);
    }
    get addedElementShortCutAction() {
        return [
            ...super.addedElementShortCutAction,
            { name: "Color", type: "colorInput", dataType: "string", description: "Changer la couleur", svgComponentIcon: "colorIcon" },
        ];
    }
    get shortCut() {
        return [
            ...super.shortCut,
            { name: "Color", type: "colorInput", dataType: "string", description: "Changer la couleur", svgComponentIcon: "colorIcon" },
        ];
    }
    get changeableProperty() {
        const parentProperty = super.changeableProperty;
        return [
            { name: "Color", type: "colorInput", dataType: "string" },
            ...parentProperty.filter(el => el.type != "objectInput" && el.type != "arrayInput"),
            {name:"RadiusTopLeft", type:"numberInput", dataType: "number"}, 
            {name:"RadiusTopRight", type:"numberInput", dataType: "number"}, 
            {name:"RadiusBottomLeft", type:"numberInput", dataType: "number"}, 
            {name:"RadiusBottomRight", type:"numberInput", dataType: "number"},
            ...parentProperty.filter(el => el.type == "objectInput" || el.type == "arrayInput")
        ];
    }
    getStyle(currentElementIndex = null) {
        return {
            ...super.getStyle(currentElementIndex),
            backgroundColor: this.Color,
            position: 'absolute',
            borderRadius: `${this.RadiusTopLeft}px ${this.RadiusTopRight}px ${this.RadiusBottomLeft}px ${this.RadiusBottomRight}px`,
        }
    }
    toExportObject(variableArray = [], ressourceArray = []) {
        return {
            ...super.toExportObject(variableArray, ressourceArray),
            color: this.hexColorValue(this.Color),
            radiusTopLeft: this.RadiusTopLeft,
            radiusTopRight: this.RadiusTopRight,
            radiusBottomLeft: this.RadiusBottomLeft,
            radiusBottomRight: this.RadiusBottomRight,
        };
    }
    toObject(minify = false) {
        let object = {
            ...super.toObject(minify),
            color: this.Color,
            radiusTopLeft: this.RadiusTopLeft,
            radiusTopRight: this.RadiusTopRight,
            radiusBottomLeft: this.RadiusBottomLeft,
            radiusBottomRight: this.RadiusBottomRight,
        };
        return object;
    }
}
